import * as angular from 'angular';
import {SetConstants, sharedRequires} from './app-module.base';

export const CommonModule: angular.IModule = angular.module('app.areas.commonModule', [
    ...sharedRequires
]);

SetConstants(CommonModule);
